<div class="valuation-page-container">
  <app-valuation-info-header
    [showGlobalSettingsButton]="true"
  ></app-valuation-info-header>
  <nz-tabset
    [(nzSelectedIndex)]="selectedTabIndex"
    (nzSelectedIndexChange)="handleTabChange($event)"
  >
    <nz-tab [nzTitle]="vsPeerTab">
      <app-valuation-page-vspeers
        [state]="state.vsPeerTab"
        [isMetaReady]="!isVsPeerMetaInProgress"
        [currentTicker]="currentTicker"
        [currentCompany]="currentCompanyId"
        [watchlistData]="watchlistData"
        [recentlyVisitedCompanies]="recentlyVisitedCompanies"
        [suggestedPeers]="suggestedPeers"
        [isTickerFilterDataReady]="
          isPeersDataReady && isWatchListAndRecentCompDataReady
        "
        [isUserPeriodCalSettingsInProgress]="isUserPeriodCalSettingsInProgress"
        [highlightGAAP]="gapSwitch"
        [visible]="selectedTabIndex === 0"
        (onPeersChange)="handlePeersChange($event, 0)"
        (showSnackBarMessage)="showSnackBarToastMessage($event)"
        (saveRatios)="updateRatios($event, 0)"
        (onCurrencyChange)="updateCurrency($event, 0)"
        (onPeriodCalculationChange)="handlePeriodCalculationChange($event)"
        (onDeletePeer)="handleDeletePeer($event)"
        (onPeriodChange)="handlePeriodChange($event, 0)"
      ></app-valuation-page-vspeers>
    </nz-tab>
    <nz-tab [nzTitle]="companyTab">
      <app-valuation-page-company
        [state]="state.companyTab"
        [isMetaReady]="!isCompanyMetaInProgress"
        [currentTicker]="currentTicker"
        [currentCompany]="currentCompanyId"
        [isUserPeriodCalSettingsInProgress]="isUserPeriodCalSettingsInProgress"
        [highlightGAAP]="gapSwitch"
        [visible]="selectedTabIndex === 1"
        (saveRatios)="updateRatios($event, 1)"
        (showSnackBarMessage)="showSnackBarToastMessage($event)"
        (onCurrencyChange)="updateCurrency($event, 1)"
        (onPeriodCalculationChange)="handlePeriodCalculationChange($event)"
        (onPeriodChange)="handlePeriodChange($event, 1)"
      >
      </app-valuation-page-company>
    </nz-tab>
    <nz-tab [nzTitle]="chartsTab">
      <app-valuation-page-charts
        [state]="state.chartTab"
        [isMetaReady]="!isChartMetaInProgress"
        [currentTicker]="currentTicker"
        [currentCompany]="currentCompanyId"
        [isTickerFilterDataReady]="
          isPeersDataReady && isWatchListAndRecentCompDataReady
        "
        [watchlistData]="watchlistData"
        [recentlyVisitedCompanies]="recentlyVisitedCompanies"
        [suggestedPeers]="suggestedPeers"
        (saveRatios)="updateRatios($event, 2)"
        (onScaleTypeFilterChange)="updateScaleType($event)"
        (onRevisionChanged)="updateRevision($event)"
        (onPeersChanged)="updateChartPeers($event)"
        (showSnackBarMessage)="showSnackBarToastMessage($event)"
        (onPeriodChange)="handlePeriodChange($event, 2)"
      >
      </app-valuation-page-charts>
    </nz-tab>
  </nz-tabset>
  <div
    *ngIf="!isVsPeerMetaInProgress && !isCompanyMetaInProgress"
    class="footer"
    style="align-self: flex-end;"
  >
    <div style="text-align: right;">
      <div *ngIf="selectedTabIndex !== 2">
        {{ state[selectedTab].magnitudeMsg }}
      </div>
      <div *ngIf="factSetAccess" style="color: #B0B0B0;">
        {{ factsetCopyRightMessage }}
      </div>
    </div>
  </div>
</div>
<!-- Snackbar -->
<ng-template #successTemplate>
  <div class="snackbar-content">
    <va-icon size="small" name="check" class="snack-icon snack-success-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #failureTemplate>
  <div class="snackbar-content">
    <va-icon 
      size="small"
      name="close-circle"
      class="snack-icon snack-failure-icon"
    ></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #infoTemplate>
  <div class="snackbar-content">
    <va-icon size="small" name="info-circle" class="snack-icon snack-info-icon"></va-icon
    ><span>{{ snackbarMessage }}</span>
    <span class="snack-cross-icon" (click)="dismissSnackBar()">
      <va-icon size="small" name="close"></va-icon>
    </span>
  </div>
</ng-template>
<ng-template #gaapInfoTemplate>
  <div class="ca-tooltip-content spacing">
    Visible Alpha selects a single standardized metric as the “Primary” version
    used to compute valuation multiples. We use GAAP values where analysts only
    forecast GAAP values or where some analysts estimate both an operating and a
    GAAP version, but the majority of forecasts are on a GAAP basis.
    <br /><br />
    In cases where there are no adjustments, or adjustments are de minimis, we
    consider both operating and GAAP basis values to be equivalent and we blend
    together both lines to maximize analyst participation.
    <br /><br />
    Our support site further illustrates this with examples
    <a
      href="https://support.visiblealpha.com/hc/en-us/articles/6254229207572"
      target="_blank"
      rel="noopener noreferrer"
      >Click here</a
    >
  </div>
</ng-template>
